import React, { useState, useEffect } from 'react'
import { Text } from "../../formitems/Index";
import { Client, Fleet, Subcatagory,stcpublished,updatesimform,published, addmanagerSim, managerDropdown, addmanagerSim2, addmanagerSim3, Phase, simform, gettingUserFleet, Insert_SimForm, Cencel_Stc_Map, add_simform, simform_Query, Get_StcFormData } from '../Simulator/SimulatorForm/SimFormQuery/SimFormQuery'
import firebase from 'firebase'
import { useQuery, useMutation } from "@apollo/client";
import { Select, Switch } from "antd";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { LeftOutlined } from "@ant-design/icons";
import Sim from './Sim'
import { InputNumber } from 'antd';
import firebases from "../../../Firebase/firebase"
import moment from 'moment';
import { useHistory } from 'react-router-dom'
const SimForm = () => {
  const history = useHistory()
  const [dropdown2, setdropdown2] = useState('')
  const [getclientId, setgetclientId] = useState('')
  const [getFleets, setgetFleets] = useState('')
  const [minutes, setminutes] = useState(30)
  const [validity, setvalidity] = useState(30)
  const [toggle, settoggle] = useState(true)
  const [search, setsearch] = useState("")
  const [toggle3, settoggle3] = useState(false)
  const [toggle4, settoggle4] = useState(false)
  const [CurrentPage, setCurrentPage] = useState(1)
  const [PostPerPage, setPostPerPage] = useState(10)
  const [manager1, setManager1] = useState('')
  const [manager2, setManager2] = useState('')
  const [manager3, setManager3] = useState('')
  const [toggle5, settoggle5] = useState(false)
  const [name, setname] = useState('')
  const [richtexttoggle, setrichtexttoggle] = useState(false)
  const [dropdown4, setdropdown4] = useState('')
  const { data } = useQuery(Client)
  const [Update, setUpdate] = useState('')
  const [dropdown, setdropdown] = useState('')
  const [dropdown5, setdropdown5] = useState('')
  const [add_new_qualification, setadd_new_qualification] = useState(false)
  const [isEdit, setisEdit] = useState(false)
  const [isView, setisView] = useState(false)
  const [users, setusers] = useState('')
  const datess = new Date()
  const datessss = moment(datess).format("YYYY/MM/DD");
  const [url, setUrl] = useState('')
  const Email = `${manager1[1]},${manager2[1]},${manager3[1]}`
  const { data: dataa } = useQuery(Fleet, {
    variables: { clientId: dropdown2[1] }
  })
  console.log(toggle)
  const { data: dataasu } = useQuery(Fleet, {
    variables: { clientId: getclientId[1] }
  })
  const { data: gettingfleet } = useQuery(gettingUserFleet, {
    variables: { id: users?.token?.claims?.user_id }
  })
  const { data: managerdropdown } = useQuery(managerDropdown, {
    variables: { id: gettingfleet?.aatmsv4_register[0]?.fleetsid, clientid: dropdown2[1] }
  })
  const { data: getSimForm } = useQuery(simform_Query, {
    variables: { clientId: getclientId[1], fleetId: getFleets[1] }
  })
  const [InsertsimForm, { data: insertsimForm }] = useMutation(Insert_SimForm, {
    refetchQueries: [{ query: simform_Query, variables: { clientId: getclientId[1], fleetId: getFleets[1] } }]
  })
  const [updatesim,{data: up}] = useMutation(updatesimform)
  const [publlishform ,{data:pub}] = useMutation(published)
  const [stcpublishedd,{data: pubb}] = useMutation(stcpublished)
  const [Cencel_Stc_map, { dataaaa }] = useMutation(Cencel_Stc_Map)
  const [Update_simforms, { dataaaaaa }] = useMutation(add_simform)
  const { data: subcatagory } = useQuery(Subcatagory)
  const { data: phase } = useQuery(Phase)
  const { data: stcListMap, refetch } = useQuery(Get_StcFormData, {
    variables: { simformname: name }

  });
  const [addmanager1, { data: managers1 }] = useMutation(addmanagerSim)
  const [addmanager2, { data: managers2 }] = useMutation(addmanagerSim2)
  const [addmanager3, { data: managers3 }] = useMutation(addmanagerSim3)
  const togle = () => {
    toggle ? settoggle(false) : settoggle(true)
  }
  const togle3 = () => {
    toggle3 ? settoggle3(false) : settoggle3(true)
  }
  const togle4 = () => {
    toggle4 ? settoggle4(false) : settoggle4(true)
  }
  const togle5 = () => {
    toggle5 ? settoggle5(false) : settoggle5(true)
  }
  const togle2 = () => {
    richtexttoggle ? setrichtexttoggle(false) : setrichtexttoggle(true)
  }
  const { data: SimForms } = useQuery(simform, {
    variables: { clientId: dropdown2[1], fleetsid: dropdown[1], phaseid: dropdown5 }
  })
  const [value, setval] = useState('')
  const handlerOnChange = (e, editor) => {
    const data = editor.getData()
    setval(data)
  }
  const Option = Select.Option;
  function onChange(value) {
    setvalidity(value)
  }
  const add_new_qualifications = () => {
    setadd_new_qualification(true)
  };
  const editfleet = () => {
    setisEdit(true)
  }
  const View = () => {
    setisView(true)
  }
  const closeForm = () => {
    setadd_new_qualification(false)
    setisEdit(false)
    setisView(false)
  };
  function onChangee(value) {
    setminutes(value)
  }
  const post = getSimForm?.aatmsv4_simforms
  const indexofLastPage = CurrentPage * PostPerPage
  const indexofFirstPost = indexofLastPage - PostPerPage
  if (post) {
    var currentPost = post.slice(indexofFirstPost, indexofLastPage)
    var paginate = pageNumber => setCurrentPage(pageNumber);
    var pageNumbers = [];
    for (var i = 1; i <= Math.ceil(post.length / PostPerPage); i++) {
      pageNumbers.push(i);
    }
  }
  useEffect(() => {
    const add_simFormss = (i) => {
      if (i !== undefined) {
        Update_simforms({
          variables: { Id: i, name: name }
        })
      }
      if (i !== undefined) {
        addmanager1({
          variables: {
            emailofficial: gettingfleet?.aatmsv4_register[0]?.emailofficial,
            clientid: dropdown2[1],
            dates: datessss,
            name: name,
            managerid: manager1[0],
            formid: i,
            siminstructorid: manager1[0]
          }
        })
      }
      if (i !== undefined && manager2[0] !== manager1[0] && manager2[0] !== manager3[0]) {
        addmanager2({
          variables: {
            emailofficial: gettingfleet?.aatmsv4_register[0]?.emailofficial,
            clientid: dropdown2[1],
            dates: datessss,
            name: name,
            managerid: manager2[0],
            formid: i,
            siminstructorid: manager2[0]
          }
        })
      }
      if (i !== undefined && manager3[0] !== manager1[0] && manager3[0] !== manager2[0]) {
        addmanager3({
          variables: {
            emailofficial: gettingfleet?.aatmsv4_register[0]?.emailofficial,
            clientid: dropdown2[1],
            dates: datessss,
            name: name,
            managerid: manager3[0],
            formid: i,
            siminstructorid: manager3[0]
          }
        })
      }
    }
    if (insertsimForm !== undefined) {
      add_simFormss(insertsimForm.insert_aatmsv4_simforms.returning[0].simformid)
    }
  }, [insertsimForm])
  useEffect(() => {
    firebases.auth().onAuthStateChanged(async user => {
      if (user) {
        const token = await user.getIdToken();
        const idTokenResult = await user.getIdTokenResult();
        setusers({
          user: user,
          token: idTokenResult,
          jwt: token
        })
      }
      else console.log("SIGNED OUT");
    })
  }, [])
  function handlepublish(publish) {
    refetch().then((stclist) => {
      let stclistdata = "";
      if (stclist.data?.aatmsv4_stcmap) {
        stclistdata = stclist.data?.aatmsv4_stcmap;
      }
      InsertsimForm({
        variables: {
          clientsid: dropdown2[1],
          clientname: dropdown2[0],
          fleetsid: dropdown[1],
          minutes: minutes,
          validity: validity,
          subcatagory: dropdown4,
          simformname: name,
          regInfo: value,
          ntc: toggle3,
          remarks: toggle4,
          result: toggle5,
          active: false,
          preview: !publish,
          published: publish,
          stage: 1,
          tc: toggle,
          email: Email,
          url: url !== "" ? url.data.url : "blank"
        }
      }).then(response => {
        if (response.data?.insert_aatmsv4_simforms) {
          let generateSimForm = firebase.functions().httpsCallable('sim-training-form');
          let requestobj = {
            aatmsv4_simforms: [{ ...response.data?.insert_aatmsv4_simforms?.returning[0] }],
            aatmsv4_stcmap: stclistdata
          }
          console.log(JSON.stringify(requestobj));
          generateSimForm(requestobj)
            .then((simformdata) => {
              console.log(simformdata);
              setUrl(simformdata)
              setTimeout(() => {
                const newWindow = window.open(simformdata.data.url, '_blank', 'noopener,noreferrer')
                if (newWindow) newWindow.opener = null
              }, 10000);
            })
            .catch(err => {
              console.log(`Error Occured!! ${err}`);
            });
        }
      });
    }).catch(err => {
      console.log(`Error Occured!! ${err}`);
    });
  }
  function handlepublishUpdate(publish) {
    refetch().then((stclist) => {
      let stclistdata = "";
      if (stclist.data?.aatmsv4_stcmap) {
        stclistdata = stclist.data?.aatmsv4_stcmap;
      }
      updatesim({
        variables: {
          simformid: insertsimForm.insert_aatmsv4_simforms.returning[0].simformid,
          clientsid: dropdown2[1],
          clientname: dropdown2[0],
          fleetsid: dropdown[1],
          minutes: minutes,
          validity: validity,
          subcategory: dropdown4,
          simformname: name,
          reginfo: value,
          ntc: toggle3,
          remarks: toggle4,
          result: toggle5,
          active: false,
          preview: true,
          published: false,
          stage: 1,
          tc: toggle,
          email: Email,
          url: url !== "" ? url.data.url : "blank",
          simformid1: insertsimForm.insert_aatmsv4_simforms.returning[0].simformid
        }
      }).then(response => {
        if (response.data?.insert_aatmsv4_simforms) {
          let generateSimForm = firebase.functions().httpsCallable('sim-training-form');
          let requestobj = {
            aatmsv4_simforms: [{ ...response.data?.insert_aatmsv4_simforms?.returning[0] }],
            aatmsv4_stcmap: stclistdata
          }
          console.log(JSON.stringify(requestobj));
          generateSimForm(requestobj)
            .then((simformdata) => {
              console.log(simformdata);
              setUrl(simformdata)
              setTimeout(() => {
                const newWindow = window.open(simformdata.data.url, '_blank', 'noopener,noreferrer')
                if (newWindow) newWindow.opener = null
              }, 10000);
            })
            .catch(err => {
              console.log(`Error Occured!! ${err}`);
            });
        }
      });
    }).catch(err => {
      console.log(`Error Occured!! ${err}`);
    });
  }
  return (
    <div className="animate__animated animate__fadeIn">
      <div className={add_new_qualification || isEdit || isView ? "hide-element" : ""}>
        {toggle === false ? <div className="category-title">Phase: {dropdown5}</div> : <div className="category-title">Sim Form </div>}
        <button className="submit-button" onClick={() => add_new_qualifications()}>
          Add New SimForm
      </button>
        <div className="table-body-container">
          <div className="table-body-header">All SimForms</div>
          <div className="client-list-divider"></div>
          <div className="table-container">
            <div className="table-header-container">
              <div className="display-record">
                <Select defaultValue="Select Page" className='pagination' onChange={e => setCurrentPage(e)} >
                  {pageNumbers && pageNumbers.map((number, i) => (
                    <Option key={i} value={number} onClick={() => paginate(number)} className='page-link'>
                      {number}
                    </Option>
                  ))}
                </Select>
              </div>
              <div className="display-record">
                <Select defaultValue="Select Client" onChange={e => setgetclientId(e)}>
                  {data?.aatmsv4_clients?.map((el, i) => (
                    <Option key={i} value={[el.clientname, el.clientsid]}>{el.clientname}</Option>
                  ))}
                </Select>
              </div>
              <div className="display-record">
                <Select defaultValue="Select Fleet" onChange={e => setgetFleets(e)}>
                  {dataasu?.aatmsv4_fleets?.map((el, i) => (
                    <Option key={i} value={[el.aircraft, el.fleetsid]}>{el.aircraft}</Option>
                  ))}
                </Select>
              </div>
              <div className="search-bar">
                <span>Search</span>
                <input type="text" value={search} onChange={(e) => setsearch(e.target.value)} />
              </div>
            </div>
            {post && currentPost?.map((data, index) => {
              if (data?.simformname.toLowerCase().includes(search.toLowerCase())) {
                return (
                  <div className="table-row-container" key={index}>
                    <div className="table-row-top">
                      <div className="items">
                        <div className="title">Client Name</div>
                        <div className="value">{data?.clientname}</div>
                      </div>
                      <div className="items">
                        <div className="title">SimForm Name</div>
                        <div className="value">{data?.simformname}</div>
                      </div>
                      <div className="items">
                        <div className="title">Sub catagory</div>
                        <div className="value">{data?.subcategory}</div>
                      </div>
                      <div className="items">
                        <div className="title">StudyMaterial</div>
                        <a href={data?.studymat} target='_blank' className="value">Visit StudyMat</a>
                      </div>
                      <div className="items">
                        <div className="title">BlankForm</div>
                        <a href={data?.blankform} target='_blank' className="value">Visit</a>
                      </div>
                    </div>
                  </div>
                );
              }
            })}
          </div>
        </div>
        <div className="print-email-container">
          <button className="print-button">
            <i className="fa fa-print" />
          Print
        </button>
          <button className="email-button">
            <i className="fa fa-envelope" />
          Email
        </button>
        </div>
      </div>
      <div >
        <div className={add_new_qualification ? "" : "hide-element"}>
          <div className="category-title">
            <span className="client-back" onClick={() => closeForm()}>
              {<LeftOutlined />} SimForm
        </span>
        Add New SimForm
      </div>
          <div className={(toggle ===false || richtexttoggle ? "hide-element" : "")}>
            <div className="toggle-form-container">
              {dropdown2 === '' ? (
                <Select value={dropdown2 ? dropdown2[0] : "Select Client"} onChange={e => setdropdown2(e)}>
                  {data?.aatmsv4_clients?.map((el, i) => (
                    <Option key={i} value={[el.clientname, el.clientsid]}>{el.clientname}</Option>
                  ))}
                </Select>
              ) : <Text disabled title="Client" value={dropdown2[0]} />}
              <Select value={dropdown ? dropdown[0] : "Select Fleet"} onChange={e => setdropdown(e)}>
                {dataa?.aatmsv4_fleets?.map((el, i) => (
                  <Option key={i} value={[el.aircraft, el.fleetsid]}>{el.aircraft}</Option>
                ))}
              </Select>
              <div>Course Duration in Minutes <span style={{ color: 'burlywood' }}> (30 to 480)</span></div>
              <InputNumber size="large" style={{ width: '300px' }} min={30} max={480} defaultValue={minutes} onChange={onChangee} />
              <br />
              <br />
              <div>Validity <span style={{ color: 'burlywood' }}>(30 to 9999)</span></div>
              <InputNumber size="large" style={{ width: '300px' }} min={30} max={9999} defaultValue={validity} onChange={onChange} />
              <br />
              <br />
              <Text disabled title="Catagory" value="Simulator" />
              <Select defaultValue="Sub Catagories" onChange={e => setdropdown4(e)}>
                {subcatagory?.aatmsv4_subcategory?.map((el, i) => (
                  <Option key={i} value={el.subcategoryid}>{el.subcategoryid}</Option>
                ))}
              </Select>
              <Text title="Name of Sim Form" value={name} onChange={e => setname(e.target.value)} />
              {name ? (
                <div>
                  <div>Add Technical Competency</div>
                  <Switch onClick={togle} /> <br /> <br />
                  <div>Add Non Technical Competency</div>
                  <Switch onClick={togle3} /><br /><br />
                  <div>Add Remarks Section</div>
                  <Switch onClick={togle4} /> <br /> <br />
                  <div>Add Result Section</div>
                  <Switch onClick={togle5} /><br /><br />
                  <div>Add Regulatory Information Section</div>
                  <Switch onClick={togle2} />
                  <div style={{ display: 'flex', margin: '10px 0px' }}>
                    <Select style={{ marginRight: '10px' }} value={manager1 ? manager1[2] : 'Select Manager-1'} onChange={e => setManager1(e)}>
                      {managerdropdown?.aatmsv4_simulatorinst?.map((el, i) => (
                        <Option key={i} value={[el.usersid,el.emailofficial,el.name]}>{el.name}</Option>
                      ))}
                    </Select>
                    <Select style={{ marginRight: '10px' }} value={manager2 ? manager2[2] : 'Select Manager-2'} onChange={e => setManager2(e)}>
                      {managerdropdown?.aatmsv4_simulatorinst?.map((el, i) => (
                        <Option key={i} value={[el.usersid,el.emailofficial,el.name]}>{el.name}</Option>
                      ))}
                    </Select>
                    <Select value={manager3 ? manager3[2] : 'Select Manager-3'} onChange={e => setManager3(e)}>
                      {managerdropdown?.aatmsv4_simulatorinst?.map((el, i) => (
                        <Option key={i} value={[el.usersid,el.emailofficial,el.name]}>{el.name}</Option>
                      ))}
                    </Select>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
          {/* add New */}
          <div className={"" + (toggle === false || richtexttoggle ? "" : "hide-element")}>
            {toggle === false ? (
              <div>
                <Select defaultValue="Select Phases" onChange={e => setdropdown5(e)}>
                  {phase?.aatmsv4_phase?.map((el, i) => (
                    <Option key={i} value={el.phaseid}>{el.phaseid}</Option>
                  ))}
                </Select>
              </div>
            ) : null}
            <div>
              {toggle === false ? <Sim data={SimForms} phase={dropdown5} name={name} togglee={settoggle} /> : null}
              {/* rich text */}
              {richtexttoggle ? (
                <div>
                  <CKEditor
                    editor={ClassicEditor}
                    onChange={handlerOnChange} />
                  <button className="cancel-button" onClick={() => setrichtexttoggle(false)}>Done</button>
                </div>
              ) : null}
            </div>
          </div>
          <div className={(toggle === false || richtexttoggle ? "hide-element" : "")}>
             {url === "" || url === undefined ? (
               <div>
                <button className="preview-button" onClick={() => { handlepublish(false); }}>
                <i className="fa fa-eye" />
                  Preview
              </button>
               <button className="cancel-button" onClick={() => {
                Cencel_Stc_map()
                closeForm()
              }}>Cancel</button>
              </div>
               ): (
                 <div>
                   <button className="submit-button" onClick={() => { 
                     publlishform({
                       variables:{
                        clientsid: dropdown2[1],
                        clientname: dropdown2[0],
                        fleetsid: dropdown[1],
                        minutes: minutes,
                        validity: validity,
                        subcategory: dropdown4,
                        simformname: name,
                        reginfo: value,
                        ntc: toggle3,
                        remarks: toggle4,
                        result: toggle5,
                        tc: toggle,
                        email: Email,
                        url: url !== "" ? url.data.url : "blank",
                        simformid1: insertsimForm.insert_aatmsv4_simforms.returning[0].simformid
                       }
                     })
                     
                     stcpublishedd({
                       variables:{
                        simformid: insertsimForm.insert_aatmsv4_simforms.returning[0].simformid,
                        simformname: name
                       }
                     })
                     setTimeout(() => {
                      setname('')
                      setdropdown2('')
                      setdropdown('')
                      setminutes(30)
                      setvalidity(30)
                      setval('')
                      settoggle3(false)
                      settoggle4(false)
                      settoggle5(false)
                      setUrl('')
                      setManager1('')
                      setManager2('')
                      setManager3('')
                      closeForm()
                    }, 5000);
                    
                    }}>Publish Form</button>
                   <button className="preview-button" onClick={() => { handlepublishUpdate(false); }}>
                    <i className="fa fa-eye" />
                      Update
                  </button>
                  <button className="preview-button">
                    <i className="fa fa-eye" />
                     <a href={url.data.url} target="_blank"> View PDF</a>
                  </button>
                  <button className="cancel-button" onClick={() => {
                    Cencel_Stc_map()
                    closeForm()
                  }}>Cancel</button>
                  </div>
               )}
           
          </div>
        </div>
      </div>
    </div>
  )
}
export default SimForm
